import React from 'react'
import Headers from '../headers/Headers'
import Footers from '../footers/Footers'
import FooterCall from '../footers/FooterCall'

const Vision_Mission = () => {
  return (
    <>
    <Headers/>
    <div>
        <h1>Vision and Mission</h1>
    </div>
    <Footers/>
    <FooterCall/>
    </>
  )
}

export default Vision_Mission
